// The values for some fields determin the logic of the form. These values come from a static file
// (display-options.json). However this file is occasionally updated. When that happens it's vital
// that form logic dependant values do not change.

/*
  NOTE: If you do need to change the value of some of theses constants, that's fine. Just check that
  the server is ok with the new value (which they will probably have given us to begin with)

  NOTE 2: This is the only file whre constants for field values should exist. This is because the values
  can be quite generic sounding such as "NORMAL". If there are two NORMAL constants in this file, we'll
  know and can prefix accordingly. We won't know if the value constants are spread across files though.

  Structure: We only add fields if they map on to field dependant logic (or will likely map on to in
  future). Before each group of constants leave a comment of the fieldId such as 'select_network' so
  we can easily keep track of what owns what
*/



// select_network
const MOBILE = 'mobile';
const FIXED = 'fixed';
const FIXEDOLO = 'fixedOlo';
const INTERNATIONAL = 'fixedInternational';

// timing
const EXPEDITED_FIXED = '1000';
const EMERGENCY_FIXED = '2000';
const LATENT_FIXED = '3000';
const NORMAL_FIXED = '4000';
const NO_IMPACT_FIXED = '5000';
const STANDARD_FIXED = '6000';
const EMERGENCY_MOBILE = 'Emergency';
const EXPEDITED_MOBILE = 'Expedited';
const LATENT_MOBILE = 'Latent';
const NORMAL_MOBILE = 'Normal';
const NO_IMPACT_MOBILE = 'No Impact';
const STANDARD_MOBILE = 'Standard';

// it_approval_required
const preImp1Yes = '10';
const preImp2Yes = '10';
const preImp3Yes = '10';
const preImp4Yes = '10';
const preImp5Yes = '10';
const preImp6Yes = '10';
const preImp6No = '20';
const preImp2No = '20';
// work-information-type (split into fixed and mobile)
/* fixed */
// human created && attachment mandatory
const BUSINESS_JUSTIFICATION_FIXED = '3000';
const INSTALL_PLAN_FIXED = '14000';
const TEST_PLAN_FIXED = '16000';
const NETWORK_IT_SECURIT_ASSESMENT_FIXED = '5200';
const SMIT_REPORT_FIXED = '9250';
const BOXI_REPORT_FIXED = '9300';
const SIA_UPLOAD_FIXED = '9350';
const CRAMER_SIA_FIXED = '9400';
const MSP_SIA_FIXED = '9450';
const CUSTOMER_NOTIFICATIONS_FIXED = '90020';
const OLO_NOTIFICATIONS_FIXED = '9600';
const BACKOUT_PLAN_FIXED = '11000';
const POSTPONEDCRQ_FIXED = '30300';
const TO_BE_RESCHEDULED_FIXED = '2000';
const AUDIT_FIXED = '24000';


// human created, attachment optional
const GENERAL_INFORMATION_FIXED = '29000';
const REQUIREMENTS_FIXED = '4000';
const SERVICE_IMPACT_ASSESSMENT_FIXED = '9000';
const INVENTORY_FIXED = '9201';
const SMIT_CHECKS_COMPLETE_FIXED = '90070';
const DARK_FIBRE_FIXED = '9500';
const HBB_UPDATE_FIXED = '9550';
const PRE_CHANGE_LAB_TESTING_FIXED = '5100';
const STATUS_UPDATE_VODAFONE_FIXDED = '35000';




/* mobile */
// human created && attachment mandatory
const TEST_PLAN_MOBILE = 'Test Plan';
const GENERAL_INFORMATION_MOBILE = 'General Information';
const REQUIREMENTS_MOBILE = 'Requirements';
// const TECHNOLOGY_RECOVERY_PLAN = 'Technology Recovery Plan';

// human created, attachment optional
const SERVICE_IMPACT_ASSESSMENT_MOBILE = 'Service Impact Assessment';


// human created && unorganised (was written before work items were organised into attachment mandatory)
const CHANGE_JUSTIFICTATION = 'Change Justification';
// const CUSTOMER_IMPACT_STATEMENT = 'Customer Impact Statement';
const INSTALL_PLAN_MOBILE = 'Install Plan';
const TEST_RESULTS_DETAILS = 'Test Results - Details';
const RISK_ASSESSMENT = 'Risk Assessment';
const CUSTOMER_IMPACT_ASSESMENT = 'Customer Impact Assesment';
const RISK_STATEMENT = 'Risk Statement';
const BUSINESS_JUSTIFICATION = 'Business Justification';
const CHANGE_ASSESSMENT = 'Change Assessment';
const POTENTIAL_PROBLEMS = 'Potential Problems';
const BACKOUT_PLAN_MOBILE = 'Backout Plan';
const BUSINESS_DESIGN = 'Business Design';
const DEVELOPMENT = 'Development';
const TECHNICAL_DESIGN = 'Technical Design';
const BACKOUT_RESULTS_DETAILS = 'Backout Results - Details';
const INSTALL_RESULTS_DETAILS = 'Install Results - Details';
const COMMAND_CENTRE_UPDATE = 'Command Centre Update';
const POST_IMPLEMENTATION_REVIEW = 'Post Implementation Review';
const CONFIGURATION_AUDIT = 'Configuration Audit';
const SLM_COMPLIANCE_AUDIT = 'SLM Compliance Audit';
const SLM_PROCESS_REVIEW = 'SLM Process Review';
const REJECTION_INFORMATION = 'Rejection Information';
const EMAIL_SYSTEM = 'Email System';
const PAGING_SYSTEM = 'Paging System';
const ALARM_POINT = 'AlarmPoint';
const TELEFONICA_UPDATE = 'Telefonica Update';
const CUSTOM_VALIDATION_ERRORS = 'Custom Validation Errors';
const APPROVAL_INFORMATION = 'Approval Information';
const APPROVAL_REQUEST = 'Approval Request';
const EXTERNAL_UPDATE = 'External Update';
const CHAT = 'Chat';
const VINE_UPDATE = 'VINE Update';
const TO_BE_RESCHEDULED_MOBILE = 'To Be Re-Scheduled';








// change_reason
const PROJECT_MOBILE = 'Project';
const NON_PROJECT_MOBILE = 'Non-Project';
const FIX_REPAIR_MOBILE = 'Fix/Repair';
// tmbs
const NOT_TMBS_AFFECTING = 'Not TMBS Affecting';
// babt
const RECORDABLE = 'Recordable';
const NOTIFIABLE = 'Notifiable';
// imapct
const IMPACT_LEVEL_1 = '1000';
const IMPACT_LEVEL_2 = '2000';
const IMPACT_LEVEL_3 = '3000';
const IMPACT_LEVEL_4 = '4000';
// company
const VODAFONE_UK = 'VODAFONE UK';
// critical_customer_list
const NONE_AFFECTED = 'None affected';


// relationship_type
const RT_CONFIGURATION_ITEM = 'AST:VF_Node';
const RT_PROJECT_CODE = 'AST:Project';
const RT_INCIDENT = 'HPD:Help Desk';

// relatsionships / config item with UA?
const configItemWithUAYes = 'Yes';
const configItemWithUANo = 'No';

/*
  These values map on to the risk value so have complex interalated logic. Some stuff may seem intuative like
  YES = true, but I feel it's safest to be verbose here
*/

// first_site_implementation
const r1Yes = 'Yes';
const r1No = 'No';
// first_site_implementation_b
const r2Yes = 'Yes';
const r2No = 'No';
// testing-status
const YES_WI_EVIDENCE_ADDED = 'Yes:WI evidence added';
const NOT_TESTED_ADD_REASON_WI = 'Not Tested: Add reason WI';
const NA_NO_TEST_ENVIROMENT = 'N/A:No Test Environment';
const NA_HARDWARE_REPLACEMENT = 'N/A:Hardware Replacement';
// acceptance-sign-off
const r4Yes = 'Yes';
const r4No = 'No';
// is-regression-possible
const r5Yes = 'Yes';
const r5No = 'No';
// regression-plan-tested
const r6Yes = 'Yes';
const r6No = 'No';
// change-scope-technology
const DATA_MIGRATION_UPGRADE = 'Data Migration/Upgrade';
const DOCUMENTATION_ONLY = 'Documentation Only';
const INFRASTRUCTURE_UPGRADE = 'Infra Upgrade';
const MAINTENANCE_CHANGE = 'Maintenance Change';
const MAJOR_INFRA_UPGRADE = 'Major Infra Upgrade';
const NEW_PRODUCT_PROJECT = 'New Product/Project';
const PRODUCT_UPGRADE_ROLLOUT = 'Product Upgrade Rollout';
const SOFTWARE_UPGRADE = 'Software Upgrade';
const STANDALONE_CHARGE = 'Standalone Change';
// change-scope-domain
const CROSS_DOMAIN = 'Cross Domain';
const CROSS_OPCO = 'Cross Opco';
const SINGLE_DOMAIN = 'Single Domain';
// cis-affected-resilient
const r9Yes = 'Yes';
const r9No = 'No';
// Change-in-Technology-Recovery-Plan
const r12Yes = 'Yes';
const r12No = 'No';
// service_outage_required
const r10Yes = 'Yes';
const r10No = 'No';
const r10Na = 'N/A - Dev/Test/Staging';
// service_outage_required_for_regression_activity
const r11Yes = 'Yes';
const r11No = 'No';
const r11Na = 'N/A - Dev/Test/Staging';
// service-outage-duration
const ZERO_MIN_BUS_CRITICAL_UP_TO_1HR_NON = '0min crit, upto 1hr non';
const LESS_THAN_1HR_BUS_CRITICAL_1_4HR_NON = 'LT 1hr bus crit,1-4hr non';
const ONE_HR_BUS_CRITICAL_MORE_THAN_4HR_NON = '>1 hr bus crit, >4 hr non';
const NO_OUTAGE = 'No Outage';

// Actual risk values. These are now labels
const RISK_LEVEL_1 = 'Risk Level 1';
const RISK_LEVEL_2 = 'Risk Level 2';
const RISK_LEVEL_3 = 'Risk Level 3';
const RISK_LEVEL_4 = 'Risk Level 4';
const RISK_LEVEL_5 = 'Risk Level 5';

// work done after 22:00 Hours on the day is consider counted as next day
// hour range from 0 to 23
const WORKING_TIME_CUTOFF_HOUR = 21;







export {
  // select_network
  MOBILE,
  FIXED,
  FIXEDOLO,
  INTERNATIONAL,
  // timing
  EMERGENCY_FIXED,
  EXPEDITED_FIXED,
  LATENT_FIXED,
  NORMAL_FIXED,
  NO_IMPACT_FIXED,
  STANDARD_FIXED,
  EMERGENCY_MOBILE,
  EXPEDITED_MOBILE,
  LATENT_MOBILE,
  NORMAL_MOBILE,
  NO_IMPACT_MOBILE,
  STANDARD_MOBILE,

  // it_approval_exclusion
  preImp1Yes,
  preImp2Yes,
  preImp3Yes,
  preImp4Yes,
  preImp5Yes,
  preImp6Yes,
  preImp6No,
  preImp2No,
  // work-information-type
  BUSINESS_JUSTIFICATION_FIXED,
  INSTALL_PLAN_FIXED,
  TEST_PLAN_FIXED,
  TEST_PLAN_MOBILE,
  // TECHNOLOGY_RECOVERY_PLAN,
  NETWORK_IT_SECURIT_ASSESMENT_FIXED,
  SMIT_REPORT_FIXED,
  BOXI_REPORT_FIXED,
  SIA_UPLOAD_FIXED,
  CRAMER_SIA_FIXED,
  MSP_SIA_FIXED,
  OLO_NOTIFICATIONS_FIXED,
  CUSTOMER_NOTIFICATIONS_FIXED,
  GENERAL_INFORMATION_FIXED,
  GENERAL_INFORMATION_MOBILE,
  REQUIREMENTS_FIXED,
  REQUIREMENTS_MOBILE,
  SERVICE_IMPACT_ASSESSMENT_FIXED,
  SERVICE_IMPACT_ASSESSMENT_MOBILE,
  INVENTORY_FIXED,
  SMIT_CHECKS_COMPLETE_FIXED,
  DARK_FIBRE_FIXED,
  HBB_UPDATE_FIXED,
  AUDIT_FIXED,
  PRE_CHANGE_LAB_TESTING_FIXED,
  TEST_RESULTS_DETAILS,
  CHANGE_JUSTIFICTATION,
  INSTALL_PLAN_MOBILE,
  RISK_STATEMENT,
  RISK_ASSESSMENT,
  CUSTOMER_IMPACT_ASSESMENT,
  BUSINESS_JUSTIFICATION,
  STATUS_UPDATE_VODAFONE_FIXDED,
  CHANGE_ASSESSMENT,
  POTENTIAL_PROBLEMS,
  BACKOUT_PLAN_FIXED,
  BACKOUT_PLAN_MOBILE,
  BUSINESS_DESIGN,
  DEVELOPMENT,
  TECHNICAL_DESIGN,
  BACKOUT_RESULTS_DETAILS,
  INSTALL_RESULTS_DETAILS,
  COMMAND_CENTRE_UPDATE,
  POST_IMPLEMENTATION_REVIEW,
  CONFIGURATION_AUDIT,
  SLM_COMPLIANCE_AUDIT,
  SLM_PROCESS_REVIEW,
  REJECTION_INFORMATION,
  EMAIL_SYSTEM,
  PAGING_SYSTEM,
  ALARM_POINT,
  TELEFONICA_UPDATE,
  CUSTOM_VALIDATION_ERRORS,
  APPROVAL_INFORMATION,
  APPROVAL_REQUEST,
  EXTERNAL_UPDATE,
  CHAT,
  VINE_UPDATE,
  TO_BE_RESCHEDULED_MOBILE,



  // change_reason
  PROJECT_MOBILE,
  NON_PROJECT_MOBILE,
  FIX_REPAIR_MOBILE,
  // tmbs
  NOT_TMBS_AFFECTING,
  // babt
  RECORDABLE,
  NOTIFIABLE,
  // imapct
  IMPACT_LEVEL_1,
  IMPACT_LEVEL_2,
  IMPACT_LEVEL_3,
  IMPACT_LEVEL_4,
  // company
  VODAFONE_UK,
  // critical_customer_list
  NONE_AFFECTED,
  // relationship_type
  RT_CONFIGURATION_ITEM,
  RT_PROJECT_CODE,
  RT_INCIDENT,
  // config item with UA
  configItemWithUAYes,
  configItemWithUANo,





  /* risk question answors */

  // first_site_implementation
  r1Yes,
  r1No,
  // first_site_implementation_b
  r2Yes,
  r2No,
  // testing-status
  YES_WI_EVIDENCE_ADDED,
  NOT_TESTED_ADD_REASON_WI,
  NA_NO_TEST_ENVIROMENT,
  NA_HARDWARE_REPLACEMENT,
  // acceptance-sign-off
  r4Yes,
  r4No,
  // is-regression-possible
  r5Yes,
  r5No,
  // regression-plan-tested
  r6Yes,
  r6No,
  // change-scope-technology
  DATA_MIGRATION_UPGRADE,
  DOCUMENTATION_ONLY,
  INFRASTRUCTURE_UPGRADE,
  MAINTENANCE_CHANGE,
  MAJOR_INFRA_UPGRADE,
  NEW_PRODUCT_PROJECT,
  PRODUCT_UPGRADE_ROLLOUT,
  SOFTWARE_UPGRADE,
  STANDALONE_CHARGE,
  // change-scope-domain
  CROSS_DOMAIN,
  CROSS_OPCO,
  SINGLE_DOMAIN,
  // cis-affected-resilient
  r9Yes,
  r9No,
  // Change-in-Technology-Recovery-Plan
  r12Yes,
  r12No,
  // service_outage_required
  r10Yes,
  r10No,
  r10Na,
  // service_outage_required_for_regression_activity
  r11Yes,
  r11No,
  r11Na,
  // service-outage-duration
  ZERO_MIN_BUS_CRITICAL_UP_TO_1HR_NON,
  LESS_THAN_1HR_BUS_CRITICAL_1_4HR_NON,
  ONE_HR_BUS_CRITICAL_MORE_THAN_4HR_NON,
  NO_OUTAGE,
  // risk levels
  RISK_LEVEL_1,
  RISK_LEVEL_2,
  RISK_LEVEL_3,
  RISK_LEVEL_4,
  RISK_LEVEL_5,
  POSTPONEDCRQ_FIXED,
  TO_BE_RESCHEDULED_FIXED,
  // working time
  WORKING_TIME_CUTOFF_HOUR,
};
